import { Stack } from '@mui/material'
import { CreditApplication } from '@src/types/CreditApplicationSchema'
import { Merchant } from '@src/types/Merchant'
import IncomeApplicantBlock from './IncomeApplicantBlock'
import StageContent from './StageContent'

interface Props {
  creditApp: CreditApplication
  merchant: Merchant
  canEdit: boolean
}

// Income descriptor for StageContent: one reused verification block per applicant.
const IncomeStageContent = ({ creditApp, merchant, canEdit }: Props) => {
  const { coApplicant } = creditApp
  const blockProps = {
    requiredDocuments: creditApp.requiredDocuments,
    creditDecision: creditApp.finalCreditDecision.decision,
    applicationStatus: creditApp.status,
    creditApplicationId: creditApp.id,
    merchant,
    financingProgramId: creditApp.financingProgramId,
    canEdit,
  }

  return (
    <StageContent
      customContent={
        <Stack spacing={3}>
          <IncomeApplicantBlock applicant={creditApp.applicant} {...blockProps} />
          {coApplicant && <IncomeApplicantBlock applicant={coApplicant} {...blockProps} />}
        </Stack>
      }
    />
  )
}

export default IncomeStageContent
